import React, { useState, UIEvent, useRef, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import IntroScrollLogo from "./sprintcore/components/IntroScrollLogo";
import Navbar from "./sprintcore/components/Navbar";
import Routes from "./sprintcore/views/Routes";
import { GoldenCursor } from "./sprintcore/components/GoldenCursor";
import "@fortawesome/fontawesome-free/css/all.min.css";
import WhatsAppFloatButton from "./sprintcore/components/WhatsAppFloatButton";

const App: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);
  const [introComplete, setIntroComplete] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleScroll = (e: UIEvent<HTMLDivElement>) => {
    setScrollY(e.currentTarget.scrollTop);
  };

  useEffect(() => {
    const introTimer = setTimeout(() => {
      scrollContainerRef.current?.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });

      setTimeout(() => {
        setIntroComplete(true);
      }, 800);
    }, 1400);

    return () => clearTimeout(introTimer);
  }, []);

  useEffect(() => {
    if (introComplete) {
      requestAnimationFrame(() => {
        scrollContainerRef.current?.scrollTo({ top: 0, behavior: "auto" });
        setScrollY(0);
      });
    }
  }, [introComplete]);

  return (
    <Router>
      <WhatsAppFloatButton />
      <GoldenCursor />
      <div
        id="app-scroll-container"
        ref={scrollContainerRef}
        className="h-screen overflow-y-scroll bg-black text-white relative"
        onScroll={handleScroll}
      >
        {!introComplete && <IntroScrollLogo scrollY={scrollY} />}

        {!introComplete && <div style={{ height: "100vh", flexShrink: 0 }} />}

        <main className="relative z-10">
          <Navbar />
          <Routes />
        </main>
      </div>
    </Router>
  );
};

export default App;
